// extracted by mini-css-extract-plugin
export default {"button":"In","primary":"Jn","fullWidth":"Kn","secondary":"Ln","nutrition":"Mn","underlined":"Nn","small":"On","medium":"Pn","info":"Qn","white":"Rn","border":"Sn","mango":"Tn","charcoal":"Un","court":"Vn","green":"Wn","spark":"Xn","linkButton":"Yn","disabled":"Zn"};
    if(module.hot) {
      // 1713211511810
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  